import $ from 'jquery';

const CONFIG = {
    FILE_INPUT: '.js-fileUpload-input',
    FILE_NAME_TEXT: '.js-fileUpload-text',
    DEFAULT_TEXT: 'No file selected',
};

/**
 * @fileOverview View handles updating the visual elements on the page
 */
export default class FileUploadView {
    /**
     * Construct the view and run initialization
     *
     * @param {string} form | Also accepts jQuery object
     */
    constructor(form) {
        /**
         * Check to see if elements are passed in as jQuery objects or strings
         */
        this.$form = (form instanceof $) ? form : $(form);

        /**
         * If element doesn't exist, exit early
         */
        if (!this.$form.length) {
            return;
        }

        /**
         * The input item of the form
         */
        this.$input = this.$form.find(CONFIG.FILE_INPUT);

        this.init();
    }

    /**
     * Initialize the view
     *
     * @method init
     */
    init() {
        this.isEnabled = false;

        return this.setupHandlers()
                   .createChildren()
                   .layout()
                   .enable();
    }

    /**
     * Binds the scope of handler functions
     * Should be run once on view initialization
     *
     * @method setupHandlers
     * @returns {FileUploadView}
     */
    setupHandlers() {
        this.handleFile = this.onChange.bind(this);
        this.handleReset = this.onReset.bind(this);
        return this;
    }

    /**
     * Create any child objects and references to DOM elements
     * Should only be run once on init of the view
     *
     * @method createChildren
     * @returns {FileUploadView}
     */
    createChildren() {


        return this;
    }

    /**
     * Update the DOM to reflect the current state of the model
     *
     * @method layout
     * @returns {FileUploadView}
     */
    layout() {
        return this;
    }

    /**
     * Disable, update the DOM, and then re-enable to create handlers for new DOM
     *
     * @method render
     */
    render() {
        this.disable();
        this.layout();
        this.enable();
    }

    /**
     * Enables the view
     * Performs binding to handlers
     * Exits early if already enabled
     *
     * @method enable
     * @returns {FileUploadView}
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }

        this.isEnabled = true;

        for (let i = 0; i < this.$input.length; i++) {
            this.$input[i].addEventListener('change', this.handleFile);
        }

        this.$form.on('reset', this.handleReset);

        return this;
    }

    /**
     * Disables the view
     * Tears down any event binding to handlers
     * Exits early if it is already disabled
     *
     * @method disable
     * @returns {FileUploadView}
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }

        for (let i = 0; i < this.$input.length; i++) {
            this.$input[i].removeEventListener('change', this.handleFile);
        }

        this.$form.off('reset', this.handleReset);

        this.isEnabled = false;

        return this;
    }

    /**
     * Destroys the view
     * Tears down any events, handlers, elements
     * Should be called when the object should be left unused
     *
     * @method destroy
     * @returns {FileUploadView}
     */
    destroy() {
        this.disable();

        return this;
    }

    /**
     * Handles file select event, changes the file name text area
     *
     * @param event
     * @returns {FileUploadView}
     */
    onChange(event) {
        const target = event.currentTarget;
        const $fileNameText = $(target).closest(this.$form).find(`${CONFIG.FILE_NAME_TEXT}[data-file-input=${$(target).attr('id')}]`);

        if (target.files.length) {
            const fileName = target.files[0].name;
            $fileNameText.text(fileName);
        }

        return this;
    }

    /**
     * Handles file select event, changes the file name text area
     *
     * @param event
     * @returns {FileUploadView}
     */
    onReset(event) {
        const $target = $(event.currentTarget);
        $target.closest(this.$form).find(CONFIG.FILE_NAME_TEXT).text(CONFIG.DEFAULT_TEXT);

        return this;
    }
}
